import { UIView } from "uicore-ts"


/**
 * A handle returned by `UIView.atomicFocusItem()`.
 *
 * When `RHFocusManager._expandItems` encounters an `RHAtomicFocusItem` in a
 * `focusableItems` list, it pushes the wrapped view directly as a single Tab
 * stop instead of recursively expanding the view's `_focusManager`.
 *
 * Use this when you want Tab to land on a view as a whole rather than cycling
 * through its internal focusable controls.
 *
 * ### Example
 * ```typescript
 * // Auto-expanded — addressCard manages its own internal Tab order
 * items.push(this.addressCard)
 *
 * // Atomic — Tab lands on the card as a single stop
 * items.push(this.addressCard.atomicFocusItem())
 * ```
 */
export class RHAtomicFocusItem {
    
    readonly view: UIView
    
    constructor(view: UIView) {
        this.view = view
    }
    
}
